import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {DEFAULT_PAGE_SIZES} from 'src/hooks/common-data-service/cached-table';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {groupsTabStateActions, groupsTabStateSelector} from '../slices/groups-tab-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const GroupsPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(groupsTabStateSelector);

    const changePage = useCallback(({currentPage}: Pagination) => {
        dispatch(groupsTabStateActions.setCurrentPage(currentPage));
    }, [dispatch]);

    const changePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(groupsTabStateActions.setCurrentPage(1));
        dispatch(groupsTabStateActions.setPageSize(pageSize));
    }, [dispatch]);

    return (
        <PaginationStripe
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={changePage}
            onChangePaginationSize={changePageSize}
            goToPage={true}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={DEFAULT_PAGE_SIZES}
        />
    );
};
